<template>
    <div>
        <div class="row mb-3 py-2" v-if="show" :class="{'border border-danger rounded': showError }">
            <div class="col-2 col-sm-1">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" stroke="#7C889B">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                </svg>
            </div>
            <div class="col-10 col-sm-11">
                <p class="text-lg">{{ question.question }}</p>
                <div v-if="showTextInput">
                    <div class="form-group">
                        <input type="text" @change="setAnswer" @keyup="setAnswer" placeholder="Ditt svar..." class="form-control">
                    </div>
                </div>
                <div v-if="showRadioInput" v-for="alternative in question.alternatives" :key="alternative.id">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" :name="questionId + '-radio'" :id="questionId + '-radio-' + alternative.id" :value="alternative.value" @change="setAnswer($event, alternative.id)">
                        <label class="form-check-label" :for="questionId + '-radio-' + alternative.id">
                            {{ alternative.label }}
                        </label>
                    </div>
                </div>

                <div v-if="showCheckBoxInput" v-for="alternative in question.alternatives" :key="alternative.id">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" :name="questionId + '-checkbox'" :id="questionId + '-checkbox-' + alternative.id" :value="alternative.value" @change="setCheckboxAnswer($event, alternative.id)">
                        <label class="form-check-label" :for="questionId + '-checkbox-' + alternative.id">
                            {{ alternative.label }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import SurveyStore from "../../state/surveyStore"

const props = defineProps(['questionId'])

const question = computed(() => SurveyStore.findQuestion(props.questionId))
const show = computed(() => SurveyStore.shouldDisplayQuestion(props.questionId))
const showTextInput = computed(() => question.value.alternative_types === 'text')
const showRadioInput = computed(() => question.value.alternative_types === 'radio')
const showCheckBoxInput = computed(() => question.value.alternative_types === 'checkbox')
const showError = computed(() => question.value.missing_input)

const setAnswer = (e, alternativeId) => {
    SurveyStore.setQuestionAnswer(props.questionId, e.target.value, alternativeId)
}

const setCheckboxAnswer = (e, alternativeId) => {
    SurveyStore.setQuestionMultiAnswer(props.questionId, e.target.value, e.target.checked, alternativeId)
}
</script>